import React from "react";
import { Typography, FormControlLabel, Switch, TextField, MenuItem } from "@material-ui/core";
import { i18n } from "../../translate/i18n";
import { getOperationalFailurePolicy, isHumanFailureQueue } from "./userConfiguration.mjs";

export default function AiOperationalFailureSettings({ profile, queues, setFieldValue }) {
  const policy = getOperationalFailurePolicy(profile);
  const t = key => i18n.t(`userModal.aiAgent.${key}`);
  if (!policy) return <Typography color="error">{t("failureUnsupported")}</Typography>;
  const available = queues.filter(isHumanFailureQueue);
  const savedUnavailable = policy.queueId && !available.some(q => Number(q.id) === policy.queueId);
  const save = patch => setFieldValue("aiAgentProfile.metadata.operationalFailurePolicy", { ...policy, ...patch });
  return <div>
    <Typography variant="subtitle2">{t("failureTitle")}</Typography>
    <Typography variant="body2" color="textSecondary">{t("failureHelp")}</Typography>
    <FormControlLabel label={t("failureTransfer")} control={<Switch color="primary" checked={policy.transferEnabled}
      onChange={event => save({ transferEnabled: event.target.checked })} />} />
    <TextField select fullWidth variant="outlined" margin="dense" label={t("failureQueue")}
      value={policy.queueId || ""} disabled={!policy.transferEnabled} error={Boolean(policy.transferEnabled && (!policy.queueId || savedUnavailable))}
      helperText={t("failureQueueHelp")} onChange={event => save({ queueId: event.target.value ? Number(event.target.value) : null })}>
      <MenuItem value="">{t("failureQueueSelect")}</MenuItem>
      {savedUnavailable && <MenuItem value={policy.queueId} disabled>{t("failureQueueUnavailable")}</MenuItem>}
      {available.map(queue => <MenuItem key={queue.id} value={queue.id}>{queue.name}</MenuItem>)}
    </TextField>
  </div>;
}
